import "./App.css";
import { getLang } from "./i18n";
import { Routes, Route, useLocation, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { useState, useEffect } from "react";
import Stories from "./components/Stories";
import LeftSidebar from "./components/LeftSidebar";
import PerformerCard from "./components/PerformerCard";
import RightSidebar from "./components/RightSidebar";
import { PerformerProvider } from "./contexts/PerformerContext";
import { PerformerAWProvider } from "./contexts/PerformerAWContext";
import { SinPartyProvider } from "./contexts/SinPartyContext";
import { StripchatProvider } from "./contexts/StripchatContext";
import { FapHouseProvider } from "./contexts/FapHouseContext";
import FapHouseSection from "./components/FapHouseSection";
import VideoCard from "./components/VideoCard";
import AWTubePlayer from "./components/AWTubePlayer";
import Header, { HEADER_HEIGHT } from "./components/Header";
import Footer from "./components/Footer";
import { useGoogleAnalytics } from "./hooks/useGoogleAnalytics";
import CategoryPage, { CATEGORIES, SLUG_ALIASES } from "./components/CategoryPage";
import PerformerProfilePage from "./components/PerformerProfilePage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import SignupPage from "./components/SignupPage";
import LangHomePage from "./components/LangHomePage";
import PushNotificationPrompt from "./components/PushNotificationPrompt";
import CategoriesNav from "./components/CategoriesNav";
import MobileSearchBar from "./components/MobileSearchBar";
import GoldShowsSection from "./components/GoldShowsSection";
import ZoeHarlowSection from "./components/ZoeHarlowSection";
// QuizFunnel removed per Remi 2026-05-28
import AgeGate from "./components/AgeGate";
import ComparePage from "./pages/ComparePage";
import TopPerformersPage from "./components/TopPerformersPage";
import LatinasEnVivoPage from "./pages/LatinasEnVivoPage";
import TagPage from "./pages/TagPage";
import VodPage from "./pages/VodPage";
import VideosPage from "./pages/VideosPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import SearchLandingPage from "./pages/SearchLandingPage";
import GeoLandingPage from "./pages/GeoLandingPage";
import GEO_PAGES from "./data/geoPages";

// ─── SEO head updater (no extra deps needed) ──────────────────────────────────
const SEOHead = ({ title, description, keywords, canonical, ogImage }) => {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (name, content, prop = false) => {
      const selector = prop
        ? `meta[property="${name}"]`
        : `meta[name="${name}"]`;
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        prop ? el.setAttribute("property", name) : el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    if (description) {
      setMeta("description", description);
      setMeta("og:description", description, true);
      setMeta("twitter:description", description);
    }
    if (keywords)    setMeta("keywords", keywords);
    if (title)       setMeta("og:title", title, true);
    if (ogImage)     setMeta("og:image", ogImage, true);
    if (canonical) {
      let link = document.querySelector("link[rel='canonical']");
      if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
      link.href = canonical;
      setMeta("og:url", canonical, true);
    }
  }, [title, description, keywords, canonical, ogImage]);
  return null;
};

// ─── Home page layout ─────────────────────────────────────────────────────────
const HomePage = ({ mobileOpen }) => (
  <>
    <SEOHead
      title="Instacamgirls — Live Cam Girls Streaming Now"
      description="Watch the hottest live cam girls streaming right now. Browse hundreds of amateur and pro models — free chat, go private anytime."
      keywords="live cam girls, free cam girls, live webcam, cam girls online, instacamgirls"
      canonical="https://instacamgirls.com/"
    />
    <Box sx={{
      display: "flex", minHeight: "100vh", position: "relative",
      flexDirection: { xs: "column", md: "row" },
      justifyContent: { xs: "flex-start", lg: "center" },
      pt: `${HEADER_HEIGHT}px`,
    }}>
      {/* Sidebar */}
      <Box component="nav" sx={{
        width: { xs: 300, lg: 300 }, flexShrink: 0,
        position: { xs: "fixed", lg: "fixed" },
        top: { xs: 0, lg: `${HEADER_HEIGHT}px` },
        height: { xs: "100vh", lg: `calc(100vh - ${HEADER_HEIGHT}px)` },
        borderRight: 1, borderColor: "divider", bgcolor: "background.paper",
        left: { xs: mobileOpen ? 0 : -300, lg: 0 },
        zIndex: 1300, transition: "left 0.3s ease",
        boxShadow: { xs: mobileOpen ? 2 : 0, lg: 0 },
      }}>
        <LeftSidebar />
      </Box>

      {/* Main content */}
      <Box sx={{ flex: { xs: 1, lg: "0 1 1200px" }, marginLeft: { xs: 0, lg: "240px" } }}>
        <Box sx={{
          display: "flex", flexDirection: { xs: "column", md: "row" },
          gap: 2, padding: 2, justifyContent: { xs: "flex-start", lg: "center" },
        }}>
          <Box sx={{ flex: { xs: 1, md: "0 1 800px" }, display: "flex", flexDirection: "column", alignItems: "center" }}>

            {/* Cambuilder Mobile Videos Smart Link — mobile only, between search and performers */}
            <Box sx={{ display: { xs: "block", lg: "none" }, width: "100%", maxWidth: 800, mb: 1 }}>
              <iframe
                src="https://as.sexad.net/as/if?p=reseller&w=100&h=100&v=10549&wl=instacamgirlslive.com&AFNO=1-70001&niche=allgirls"
                allowTransparency="true"
                width="100%"
                height="120"
                style={{ maxWidth: "100%", border: "none", display: "block" }}
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
                scrolling="no"
                title="Mobile Videos"
              />
            </Box>

{/* Kwiky — TikTok-style short clips banner — mobile only */}
            <Box sx={{ display: { xs: 'flex', md: 'none' }, width: '100%', maxWidth: 800, mb: 1, justifyContent: 'center' }}>
              <a
                href="https://kwiky.com/landing/click/cams?AFNO=2-162513.49936"
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: 'block', width: '100%', textDecoration: 'none' }}
              >
                <Box sx={{
                  background: 'linear-gradient(90deg, #ff2d55 0%, #ff6b35 100%)',
                  borderRadius: '12px',
                  px: 2, py: 1.2,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1.5,
                }}>
                  <span style={{ fontSize: 22 }}>🎬</span>
                  <Box>
                    <div style={{ color: '#fff', fontWeight: 800, fontSize: '0.95rem', lineHeight: 1.2 }}>Watch Short Clips First</div>
                    <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: '0.78rem' }}>TikTok-style cam content · Go live anytime</div>
                  </Box>
                  <span style={{ color: '#fff', fontSize: 18, marginLeft: 'auto' }}>›</span>
                </Box>
              </a>
            </Box>

            {/* Gold Shows */}
            <GoldShowsSection />

            {/* FapHouse Videos */}
            <FapHouseSection />

            {/* Category nav */}
            <Box sx={{ width: "100%", maxWidth: 800, mb: 2 }}>
              <CategoriesNav />
            </Box>
            {/* Stories */}
            <Box sx={{ width: "100%", maxWidth: 800, mb: 3 }}>
              <Stories />
            </Box>
            {/* AWEmpire live tube player — responsive */}
            <AWTubePlayer />

            {/* Zoe Harlow — AI Digital Twin */}
            <ZoeHarlowSection />

            <div className="twrd" />



            {/* Performer feed */}
            <Box sx={{ width: "100%", maxWidth: 800, display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>
              <PerformerCard />
            </Box>
          </Box>

          {/* Desktop right sidebar */}
          <Box sx={{ width: { md: 300 }, flexShrink: 0, display: { xs: "none", md: "flex" }, justifyContent: { md: "flex-start", lg: "center" } }}>
            <RightSidebar />
          </Box>
        </Box>
      </Box>
    </Box>
  </>
);

// ─── Category page wrapper with SEO ──────────────────────────────────────────
const CategoryPageWrapper = () => {
  const { slug: rawSlug } = useParams();
  // Resolve alias slugs to canonical slugs (same logic as CategoryPage internals)
  const slug = (rawSlug && SLUG_ALIASES[rawSlug.toLowerCase()]) || rawSlug;
  const config = CATEGORIES[slug];
  // Use a shared high-quality OG preview image for all category pages
  const categoryOgImage = "https://instacamgirls.com/logo512.png";
  return (
    <>
      {config && (
        <SEOHead
          title={`${config.title} — Live Now | Instacamgirls`}
          description={config.metaDescription}
          keywords={config.keywords}
          canonical={`https://instacamgirls.com/category/${slug}`}
          ogImage={categoryOgImage}
        />
      )}
      <CategoryPage />
    </>
  );
};

// ─── App root ─────────────────────────────────────────────────────────────────
function SmartHome(props) {
  const location = useLocation();
  const lang = getLang(location.search);
  if (lang === "fr" || lang === "es" || lang === "de") {
    return <LangHomePage />;
  }
  return <HomePage {...props} />;
}

function App() {
  const [mobileOpen, setMobileOpen] = useState(false);
  // const [showQuiz, setShowQuiz] = useState(false); // quiz removed
  const [clickCount, setClickCount] = useState(0);
  const [ageVerified, setAgeVerified] = useState(() => {
    try { return !!localStorage.getItem('icg_age_verified'); } catch(e) { return false; }
  });

  // Device tracking ping — fires once per session on load
  useEffect(() => {
    try {
      const sid = localStorage.getItem('chat_session') || 'anon';
      fetch(`${process.env.REACT_APP_API_URL}/api/device-ping`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_id: sid, page: window.location.pathname }),
      }).catch(() => {});
    } catch(e) {}
  }, []);

  // TwinRed — load adlib.js once into <head> on mount (idempotent)
  useEffect(() => {
    if (!document.querySelector('script[data-tr-adlib]')) {
      const sc = document.createElement('script');
      sc.type = 'text/javascript'; sc.async = true;
      sc.src = 'https://s.ad.twinrdengine.com/adlib.js';
      sc.setAttribute('data-tr-adlib', '1');
      document.head.appendChild(sc);
    }
  }, []);

  // TwinRed Popunder — fires once per session on first user click
  useEffect(() => {
    const fired = (() => { try { return !!sessionStorage.getItem('tr_popunder'); } catch(e) { return false; } })();
    if (fired) return;
    const handleFirstClick = () => {
      try { sessionStorage.setItem('tr_popunder', '1'); } catch(e) {}
      const ins = document.createElement('ins');
      ins.setAttribute('data-tr-zone', '01DXF6DT004000000000002P2F');
      ins.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none;';
      document.body.appendChild(ins);
    };
    document.addEventListener('click', handleFirstClick, { once: true });
    return () => document.removeEventListener('click', handleFirstClick);
  }, []);

  // TwinRed Interstitial — fires once per session on page load (3s delay)
  useEffect(() => {
    const fired = (() => { try { return !!sessionStorage.getItem('tr_interstitial'); } catch(e) { return false; } })();
    if (fired) return;
    const t = setTimeout(() => {
      try { sessionStorage.setItem('tr_interstitial', '1'); } catch(e) {}
      const ins = document.createElement('ins');
      ins.setAttribute('data-tr-zone', '01DXF6DT004000000000002P2K');
      ins.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none;';
      document.body.appendChild(ins);
    }, 3000);
    return () => clearTimeout(t);
  }, []);

  // Quiz removed per Remi 2026-05-28 — block below disabled
  // Show quiz on second click (not immediately on load)
  useEffect(() => {
    const alreadyTaken = (() => { try { return !!localStorage.getItem('xen_prefs'); } catch(e) { return false; } })();
    if (true) return; // quiz disabled
    if (alreadyTaken) return;

    const handleClick = (e) => {
      // Don't count clicks on buttons, links, chat, or form elements
      const tag = e.target.tagName;
      const isInteractive = ['BUTTON','A','INPUT','TEXTAREA','SELECT'].includes(tag)
        || e.target.closest('button,a,[role="button"],[data-chat],[data-quiz]')
        || e.target.closest('.MuiButton-root,.MuiIconButton-root,.MuiTab-root');
      if (isInteractive) return;

      setClickCount(prev => {
        const next = prev + 1;
        if (next >= 2) {
          // setShowQuiz(true); // quiz removed
          document.removeEventListener('click', handleClick);
        }
        return next;
      });
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);
  useGoogleAnalytics();

  return (
    <PerformerProvider>
      <PerformerAWProvider>
      <FapHouseProvider>
      <SinPartyProvider>
      <StripchatProvider>
        <div className="App" style={{ overflowX: 'clip', maxWidth: '100vw' }}>
          <AgeGate onVerified={() => setAgeVerified(true)} />
          <Header onMenuToggle={() => setMobileOpen(!mobileOpen)} />

          {/* QuizFunnel removed per Remi 2026-05-28 */}
          <Routes>
            <Route path="/" element={<SmartHome mobileOpen={mobileOpen} />} />
            <Route path="/category/:slug" element={<CategoryPageWrapper />} />
            <Route path="/cam/:name" element={<PerformerProfilePage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/fr" element={<LangHomePage />} />
            <Route path="/fr/" element={<LangHomePage />} />
            <Route path="/es" element={<LangHomePage />} />
            <Route path="/es/" element={<LangHomePage />} />
            <Route path="/de" element={<LangHomePage />} />
            <Route path="/de/" element={<LangHomePage />} />
            <Route path="/join" element={<SignupPage />} />
            <Route path="/compare" element={<ComparePage />} />
            {/* Q2 SEO Roadmap — new pages */}
            <Route path="/es/latinas-en-vivo" element={<LatinasEnVivoPage />} />
            <Route path="/tag/:tag" element={<TagPage />} />
            <Route path="/vod/:id" element={<VodPage />} />
            <Route path="/videos" element={<VideosPage />} />
            <Route path="/videos/:category" element={<VideosPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/search/:keyword" element={<SearchLandingPage />} />
            {/* Geo landing pages — Option B SEO */}
            {Object.values(GEO_PAGES).map((geo) => (
              <Route
                key={geo.path}
                path={geo.path}
                element={<GeoLandingPage config={geo} />}
              />
            ))}
            <Route path="/top-rated" element={
              <>
                <SEOHead
                  title="Top Rated Cam Girls — Best Live Performers | Instacamgirls"
                  description="Browse the best and most popular live cam girls right now. Trending, top-rated, new girls, and gold show performers — all streaming free. Go private anytime."
                  keywords="top rated cam girls, best cam girls, trending cam girls, popular cam models, top live cam"
                  canonical="https://instacamgirls.com/top-rated"
                />
                <TopPerformersPage />
              </>
            } />
            {/* teen-cam-girls-18 alias → category slug */}
            <Route path="/category/teen-cam-girls-18" element={<CategoryPageWrapper />} />
            {/* Catch-all → home */}
            <Route path="*" element={<HomePage mobileOpen={mobileOpen} />} />
          </Routes>

          <PushNotificationPrompt />
          <Box sx={{ width: "100%", display: "flex", justifyContent: "center", bgcolor: "background.paper", borderTop: 1, borderColor: "divider" }}>
            <Footer />
          </Box>
        </div>
      </StripchatProvider>
      </SinPartyProvider>
      </FapHouseProvider>
      </PerformerAWProvider>
    </PerformerProvider>
  );
}

export default App;
